import React, { useState } from 'react'
import './RedirectCard.css'
import Text from '../text/Text'
import blueChevron from '../../assets/icons/blue-right-chevron.png'

interface RedirectProps {
    iconActiveName?: string
    iconName: string
    title: string
    subtitle: string
    handleOnPress: () => void
}

export default function RedirectCard({
    iconActiveName,
    iconName,
    title,
    subtitle,
    handleOnPress,
}: RedirectProps) {
    const [hovered, setHovered] = useState(false)

    return (
        <div
            className="landing"
            onClick={handleOnPress}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {hovered && iconActiveName ? (
                <img src={iconActiveName} />
            ) : (
                <img src={iconName} />
            )}

            <div className="titleStyle">
                <Text
                    label={title}
                    fontSize={14}
                    fontWeight={600}
                    fontFamily={'Montserrat'}
                    textAlign={'center'}
                />
            </div>
            <div className="centeredSubtitle">
                <Text
                    label={subtitle}
                    fontSize={14}
                    fontWeight={400}
                    fontFamily={'Montserrat'}
                />
            </div>
            <img src={blueChevron} className="blueChevron" />
        </div>
    )
}
